import { createApp } from 'vue';
import { createPinia, setMapStoreSuffix } from 'pinia';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { loadFonts } from './plugins/webfontloader';
import '@/assets/css/styles.css';
import './assets/css/main.css';
import 'vuetify/styles';

loadFonts();
setMapStoreSuffix('_map');
createApp(App)
  .use(router)
  .use(createPinia())
  .use(vuetify)
  .mount('#app');
